<template>
	
    <div>

      <el-dialog :title="dialTitle"  :visible.sync="dialogVisible" width="80%" ref="sel_el" >
        <div>
        <v-form-render :form-json="dialFormJson" :form-data="dialFormData" :option-data="dialOptionData" ref="vFormRefdilog">
        </v-form-render>
        </div>
      
      </el-dialog>
   
      
      <v-form-render :form-json="formJson" :globalDsv ="globalDsv" :form-data="formData" :option-data="optionData" ref="vFormRef">
      </v-form-render>
    
    </div>
  </template>
  <script>
    import * as forms from '@/api/forms'
    import  * as getMaoToken  from '@/utils/auth'
    export default {
   
      data() {
        return {
          formJson: {},
          formData: {'goodsId':'',"saleManId":""},
          optionData: {},
          dialogVisible: false,//弹窗显示
          dialFormJson: {"widgetList":[],"formConfig":{"modelName":"formData","refName":"vForm","rulesName":"rules","labelWidth":80,"labelPosition":"left","size":"","labelAlign":"label-left-align","cssCode":"","customClass":"","functions":"","layoutType":"PC","onFormCreated":"","onFormMounted":"","onFormDataChange":"","onFormValidate":""}},//弹窗渲染数据
          dialFormData:{},//弹窗表单数据
          dialOptionData:{},//弹窗选择数据
          dialTitle:"弹出框",//更新20230707代码
          globalDsv: {
                   x_token:getMaoToken.getToken(),
                   api_url:process.env.VUE_APP_BASE_API,
                   sel_formdata:{},//formdata
                   sel_mainds:[],  //获取弹出框单据主数据集的值
                   sel_djmxds:[]   //获取弹出框表格明细数据的值
               },
           myglobalDsv: {
                   x_token:getMaoToken.getToken(),
                   api_url:process.env.VUE_APP_BASE_API,
                   sel_formdata:{},//formdata
                   sel_mainds:[],  //获取弹出框单据主数据集的值
                   sel_djmxds:[]   //获取弹出框表格明细数据的值
               },
          renderObject1:{},
          renderObject2:{},
        }
       
      },
      methods: {
        submitForm() {
          this.$refs.vFormRef.getFormData().then(formData => {
            // Form Validation OK
            alert( JSON.stringify(formData) )
          }).catch(error => {
            // Form Validation failed
            this.$message.error(error)
          })
        },

        fetchData(id) {
         return forms
            .get({"id":id})
            
        },
        show (event) {
                // 此处可以使用判断条件控制是否需要阻止右键
               event.preventDefault(); 
            },
        //选择器中设置已选择数据
        setSelDataResult(formdata,dsmaindata,djmxdata){
         
          this.globalDsv.sel_formdata = formdata
          this.globalDsv.sel_mainds = dsmaindata
          this.globalDsv.sel_djmxds = djmxdata

          console.log( this.globalDsv);
          this.dialogVisible = false;
          
        },
        //获取选择器中的数据
        getSelDataResult(){

        //  this.$message.error('获取已选择数据项')      
          return this.globalDsv;

        },
        mysetFormData(data)
        {
            this.$refs.vFormRef.setFormData(data)
             this.dialogVisible = false;
        },
		closeDialog(){
			this.dialogVisible = false;
		},
        openDialog(formid,key){
		//	this.$refs.vFormRefdilog.clearFormTemplates()
          console.log("单据唯一ID" + formid)
          this.dialogVisible = true
          var objPage1 = this;
          this.$refs.sel_el.$nextTick(()=>{
      
          this.fetchData(formid).then(res => {
            if (res.code == 200) {
              console.log(this.$refs.vFormRefdilog)     
              this.$refs.vFormRefdilog.setFormJson(res.result.contentData)
              this.formData.con = key
			  
             // console.log('con'+this.$refs.vFormRefdilog.getWidgetRef('con').getValue()) 
              this.$refs.vFormRefdilog.setFormData(this.formData)

              if(!this.myglobalDsv.parentEL)
              {
                this.myglobalDsv.parentEL = this
              }
              
              this.$refs.vFormRefdilog.globalDsv = this.globalDsv         
              this.$nextTick(() => {      
                this.renderObject1 = this.$refs.vFormRefdilog;
                this.$refs.vFormRefdilog.addEC('myEC', objPage1)
              })
            }
          })

            
          })

        
           
        },       
          cancel:function()
         {
          this.$confirm('确认关闭？')
              .then(() => {
                this.dialogVisible = false
               // done();
              })
              .catch(() => {});
         }

      },
   
      mounted(){
        
           window.globalConstUtil.setGlobal({
                      x_token:getMaoToken.getToken(),
                      api_url:process.env.VUE_APP_BASE_API,
                      params:{//获取表单列表参数
                            orgId: "7cb9b236-c99b-4676-b9ff-037f2d913a3a"
                            ,page:1
                            ,limit:200
                          },
                      contentType:'application/x-www-form-urlencoded'
                          
                    })
          this.fetchData("31482caf-da83-422a-90e9-36f959b160eb").then(res => {
            if (res.code == 200) {
              var objPage = this;
              console.log(res.result.contentData)
              this.$refs.vFormRef.setFormJson(res.result.contentData)         
              this.$nextTick(() => {
                this.$refs.vFormRef.addEC('myEC', objPage) 
                this.globalDsv.parentEL= this         
                this.$refs.vFormRef.globalDsv = this.globalDsv
                //this.$refs.vFormRef.setFormData(res.result.contentData)
              })
            }
          })
          this.renderObject2 = this.$refs.vFormRefdilog;
      }     
    }

  </script>